import {createContext, FC, PropsWithChildren} from "react";
import {useLocalStorage} from "../helpers/useLocalStorage";

interface ITeamViewerMessageBarContext {
    bottomMessageBarHidden: boolean;
    setBottomMessageBarHidden: (value: boolean) => void;
}

const TeamViewerMessageBarContext = createContext<ITeamViewerMessageBarContext>(
    {
        bottomMessageBarHidden: false,
        setBottomMessageBarHidden: () => {
        },
    },
);

export const TeamViewerMessageBarEntry: FC<PropsWithChildren> = ({
                                                                     children,
                                                                 }) => {
    const [temporarilyHidden, setTemporarilyHidden] = useLocalStorage(
        "temporarilyHidden",
        false,
    );

    return (
        <TeamViewerMessageBarContext.Provider
            value={{
                setBottomMessageBarHidden: setTemporarilyHidden,
                bottomMessageBarHidden: temporarilyHidden,
            }}
        >
            {children}
        </TeamViewerMessageBarContext.Provider>
    );
};

export default TeamViewerMessageBarContext;
